import React, { Component } from 'react'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import Auth from '../../Modules/Auth'
import BillItem from './BillItem'
import './BillList.scss'
import ReactGA from 'react-ga'

class BillList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            contracts: null,
        }
    }

    UNSAFE_componentWillMount() {
        if (this.props.cookies.get('demo') === 'true') {
            alert('접근 권한이 없습니다.')
            return
        }
        this.loadContract()
    }

    loadContract = () => {
        const { cookies } = this.props
        //`${BACKEND_HOST}/contract-bills/test/${this.props.cookies.get('project')}`
        //
        axios
            .get(`${BACKEND_HOST}/contract-bills?sent=false&order_by=-createdAt`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({
                    contracts: res.data.data,
                })
                // console.log(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    Comma = (num) => {
        if (typeof num === 'number') {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
            return ''
        }
    }

    renderList = () => {
        const List = this.state.contracts.map((item, i) => {
            console.log(item)
            return <BillItem item={item} key={i} />
        })
        return List
    }

    render() {
        if (this.state.contracts) {
            return (
                <div className="payment_list_wrap">
                    <div className="noti_text pc_v_impo">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <g fill="none" fillRule="evenodd" stroke="#A2A7AE" strokeWidth="1.3">
                                <circle cx="7" cy="7" r="6.35" />
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4.963 4.9a2.1 2.1 0 0 1 4.081.7c0 1.4-2.1 2.1-2.1 2.1v2.774"
                                />
                            </g>
                        </svg>
                        <p>시공사와 건축주와의 청구서 내역입니다.</p>
                    </div>

                    <div className="list_wrap">{this.state.contracts.length > 0 && this.renderList()}</div>
                </div>
            )
        }
        return <div />
    }
}

export default withCookies(BillList)



// WEBPACK FOOTER //
// ./Src/Components/Contract/BillList.js